import { toast } from "react-toastify";
import { deleteData, getData, putData } from "../global/Globalapi";

 export const handleRemove = async (id,setCart,userId,setRefresh) => {
    console.log('deleted id',id)
    try {
      await deleteData(`/cart/${userId}/${id}`);
      // Remove from frontend state too
      setCart((prevCart) =>
        prevCart.filter((item) => item.id !== id)
      );
      setRefresh(prev => !prev);
    } catch (err) {
      console.error("Error removing cart item:", err);
    }
  };

//  export const handleIncrease = async (id,setRefresh) => {
//     try {
//       await putData(`/cart/increase/${id}`); // PUT request
//       setRefresh(prev => !prev); // Refresh cart
//     } catch (err) {
//       console.error("Error increasing quantity:", err);
//     }
//   };
export const handleIncrease = async (id, setCart, setRefresh) => {
  // ✅ Update UI instantly
  setCart(prev =>
    prev.map(item =>
      item.id === id
        ? {
            ...item,
            quantity: item.quantity + 1,
            amount: (item.quantity + 1) * item.unit_price
          }
        : item
    )
  );

  try {
    // ✅ Backend update
    await putData(`/cart/increase/${id}`);
  } catch (err) {
    console.error("Error increasing quantity:", err);
    setRefresh(prev => !prev); // fallback refresh
  }
};



 export  const handleDecrease = async (id, quantity,setRefresh) => {
    if (quantity <= 1) {
      toast.warning("Quantity cannot go below 1");
      return;
    }
  
    try {
      await putData(`/cart/decrease/${id}`); // PUT request
      setRefresh(prev => !prev); // Refresh cart
    } catch (err) {
      console.error("Error decreasing quantity:", err);
    }
  };

export const fetchCartItems = async (userId,setCart) => {
      try {
        setCart([]);
        console.log(userId)
        const res = await getData(`/cart/${userId}`);
        console.log(res);
        setCart(res.data);
      } catch (err) {
        console.error("Error fetching cart:", err);
      }}